// src/utils/visuallyHidden.ts
var visuallyHidden = {
    position: "absolute",
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    // COMMA-separated. The space-separated form is legal in modern CSS but is the one some
    // engines ignore, which would quietly defeat the fallback this property is here to be —
    // and every other copy of this recipe in the estate uses commas, so the definition they are
    // all meant to converge onto was the odd one out. Raised by Copilot on the PR.
    clip: "rect(0, 0, 0, 0)",
    // The non-deprecated half of the pair, and both are kept so the element stays hidden on every
    // engine we ship to: Safari prefers `clip-path` and plain `clip` is deprecated in CSS Masking.
    // `@repo/design-system`'s `Combobox` already carried both; this definition did not, and since it
    // is the one the estate is meant to converge onto, the weaker recipe would have been the one
    // that spread. Raised in review.
    clipPath: "inset(50%)",
    whiteSpace: "nowrap",
    border: 0
};
export { visuallyHidden };
